<script setup>
import { computed, ref } from 'vue';
import { useStateStore } from '@/stores/state.store';
import LangChooser from '@/components/common/LangChooser.vue';

const stateStore = useStateStore();

const mainColor = stateStore.getColors.mainColor;
const backgroundColor = stateStore.getColors.backgroundColor;
const isClosed = ref(false);

const windowVisible = computed(() => {
  return !isClosed.value && !localStorage.getItem('acceptedState');
});

function acceptState() {
  localStorage.setItem('acceptedState', true);
  isClosed.value = true;
  window.location.reload();
}
</script>

<template>
  <div v-if="windowVisible" class="policy">
    <LangChooser
      :main-color="mainColor"
      :background-color="backgroundColor"
      :store="stateStore"
    />
    <div class="pop-up">
      <h1 class="header text">
        {{ $t('appCore.apps.popUp.privacyPolicy.header') }}
      </h1>
      <i18n-t
        class="text normal"
        keypath="appCore.apps.popUp.privacyPolicy.text"
        tag="p"
        scope="global"
      >
        <template #state>
          <a class="link" href="https://wspomnieniazwesela.pl/policies/state">
            <span class="link text">{{
              $t('appCore.apps.popUp.privacyPolicy.state')
            }}</span>
          </a>
        </template>
        <template #policy>
          <a class="link" href="https://wspomnieniazwesela.pl/policies/privacy">
            <span class="link text">{{
              $t('appCore.apps.popUp.privacyPolicy.policy')
            }}</span>
          </a>
        </template>
      </i18n-t>
      <div class="buttons">
        <a class="text decline" href="https://www.google.com/">{{
          $t('appCore.apps.popUp.privacyPolicy.decline')
        }}</a>
        <button class="text accept" @click="acceptState">
          {{ $t('appCore.apps.popUp.privacyPolicy.accept') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styleConstans';

.policy {
  position: fixed;
  transition: 0.5s ease all;
  z-index: 100;
  backdrop-filter: blur(10px);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .pop-up {
    position: relative;
    max-width: 600px;
    background-color: v-bind(backgroundColor);
    border-radius: 11px;
    border: 1px solid v-bind(mainColor);
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
    padding: 15px 35px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 25px;
    margin: 0 5%;

    @media screen and (max-width: $media-phone) {
      height: auto;
      gap: 15px;
    }

    .text {
      color: v-bind(mainColor);
      font-family: 'MADE Mirage', serif;
      font-size: 15.981px;
      font-style: normal;
      line-height: 150%; /* 30px */
      font-weight: 700;
      text-align: center;
    }

    .header {
      text-align: center;
      font-size: 24px;
    }

    .normal {
      font-weight: 500;
      width: auto;
    }

    .link {
      text-decoration-line: underline;
    }

    .buttons {
      display: flex;
      flex-flow: row wrap-reverse;
      justify-content: space-between;
      align-items: center;
      width: 85%;
      margin: 0% auto;
      gap: 15px 45px;

      @media screen and (max-width: $media-phone) {
        justify-content: center;
      }

      .accept {
        border-radius: 9.491px;
        border: 1.227px solid v-bind(mainColor);
        padding: 6px 15px;
        transition: background-color 1s ease;
        width: auto;

        &:hover {
          background-color: v-bind(mainColor);
          color: v-bind(backgroundColor);
          cursor: pointer;
        }
      }

      .decline {
        color: v-bind(mainColor);
        display: flex;
        justify-content: center;
        align-items: center;
        width: auto;
      }
    }
  }
}
</style>
